import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  InputAdornment,
  IconButton,
  CircularProgress
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { api } from "./api";
import logo from '../assets/logoVerde.svg';
import fondo from '../assets/esquina.jpg';
import ComputerIcon from '@mui/icons-material/Computer';
import { useTurnstile } from "../hooks/useTurnstile";

const Login = ({ setUser }) => {
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: '', contraseña: '' });
  const [error, setError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // --- NUEVO: Hook Turnstile ---
  const { containerRef, token, loading: captchaLoading, failover, reset } = useTurnstile();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleLogin = async () => {
    if (!form.email || !form.contraseña) {
      setError("Completa todos los campos");
      return;
    }

    // Validación Captcha
    if (!token && !failover) {
      setError("Por favor, completa el Captcha");
      return;
    }

    const captchaBypass = failover ? true : false;

    setIsLoading(true);
    setError('');

    try {
      const data = await api.auth.loginUser(
        form.email,
        form.contraseña,
        token,
        captchaBypass
      );

      setUser(data.user);
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.token);

      navigate("/dashboard");
    } catch (err) {
        reset();
      setSnackbar({
        open: true,
        message: err.error || "Usuario o contraseña incorrecta",
        severity: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: 'relative',
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0,0,0,0.4)',
          zIndex: 1
        }
      }}
    >
      <Box position="relative" zIndex={2} width="100%" maxWidth={400} sx={{ m: { xs: 2, sm: 3 } }}>
        <Box
          sx={{
            backgroundColor: 'white',
            padding: { xs: 4, sm: 3 },
            borderRadius: 2,
            boxShadow: 3,
            width: '100%',
            textAlign: 'center',
          }}
        >
          <Box mb={1}>
            <img src={logo} alt="Logo" style={{ width: 80, height: "auto" }} />
          </Box>

          <Typography
            variant="subtitle1"
            mb={2}
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: 15, sm: 14 },
              lineHeight: 1.3
            }}
          >
            Cooperativa de Servicios Públicos, Sociales y Vivienda de Avellaneda Ltda.
          </Typography>

          <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
            <ComputerIcon sx={{ color: '#6aae3b', mr: 1, fontSize: { xs: 26, sm: 22 } }} />
            <Typography
              variant="h5"
              sx={{
                color: '#6aae3b',
                fontWeight: 600,
                fontSize: { xs: 20, sm: 22 },
                lineHeight: 1.2
              }}
            >
              Oficina Virtual
            </Typography>
          </Box>

          <Box
            sx={{
              width: 50,
              height: 2,
              backgroundColor: '#6aae3b',
              margin: '0 auto',
              borderRadius: 1,
              mb: 2
            }}
          />

          <TextField
            name="email"
            label="Email"
            fullWidth
            margin="dense"
            size="small"
            onChange={handleChange}
            value={form.email}
            sx={{ '& .MuiInputBase-root': { height: 40 } }}
          />

          <TextField
            name="contraseña"
            type={showPassword ? 'text' : 'password'}
            label="Contraseña"
            fullWidth
            margin="dense"
            size="small"
            onChange={handleChange}
            value={form.contraseña}
            sx={{ '& .MuiInputBase-root': { height: 40 } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          {error && (
            <Typography color="error" variant="body2" mb={1} sx={{ textAlign: 'left' }}>
              {error}
            </Typography>
          )}

          {/* CAPTCHA */}
          <Box display="flex" justifyContent="center" mb={2} minHeight={55}>
            {failover ? (
              <Alert severity="warning">
                No se pudo cargar el servicio de seguridad.
              </Alert>
            ) : (
              <div ref={containerRef} />
            )}
          </Box>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleLogin}
            sx={{ mt: 1 }}
            disabled={(!token && !failover) || isLoading}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Iniciar sesión'}
          </Button>

          {/* <Button
            variant="text"
            size="small"
            onClick={() => navigate('/forgot-password')}
            sx={{ textTransform: 'none', fontSize: '0.85rem', color: 'primary.main' }}
          >
            Olvidé mi contraseña
          </Button>
           */}

           {/* Contenedor horizontal para los dos links */}
<Box
  display="flex"
  justifyContent="center"
  alignItems="center"
  gap={1}
  mb={1}
  mt={1}
  sx={{ fontSize: '0.85rem' }}
>
  <Button
    variant="text"
    size="small"
    onClick={() => navigate('/forgot-password')}
    sx={{ textTransform: 'none', color: 'primary.main', minWidth: 'auto', padding: 0 }}
  >
    Olvidé mi contraseña
  </Button>

  <Typography
    variant="body2"
    component="span"
    sx={{ color: 'text.secondary', userSelect: 'none' }}
  >
    |
  </Typography>

  <Button
    variant="text"
    size="small"
    onClick={() => navigate('/loginsimple')}
    sx={{ textTransform: 'none', color: 'primary.main', minWidth: 'auto', padding: 0 }}
  >
    Ingresar sin contraseña
  </Button>
</Box>


          <Button
            variant="outlined"
            fullWidth
            sx={{ mt: 1 }}
            onClick={() => navigate('/register')}
          >
            Registrarme
          </Button>

          <Snackbar
            open={snackbar.open}
            autoHideDuration={4000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
              {snackbar.message}
            </Alert>
          </Snackbar>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
